import { Button, Input, message, Modal, Steps } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  createDisputeComment,
  CreateDisputeComments,
  getDisputeComments,
} from "../../actions/disputes";
import Comment from "../../assets/icons/comment.png";
import History from "../../assets/icons/time_icon.png";
import usePayAxios from "../../config/useAxios";
import useHandleResponse from "../../config/useHandleResponse";
import { amountFormat } from "../../utils";
import ReportDisputeModal from "../Cards/RaiseDisputeModal";
import BaseCurrency from "../Common/BaseCurrency";
import NoCommentsComponent from "../Common/NoComentsComponent";
import NodataComponent from "../Common/NodataComponent";
import { apis } from "../../config/APIs";
const { Step } = Steps;
const DisputeModal = ({ isModalVisible, handleCancel }) => {
  const [tab, setTab] = React.useState("details");
  const [isModalDispute, setIsModalDispute] = React.useState(false);
  const { onCall, data } = usePayAxios({
    api: apis.disputeHistories,
    method: "get",
  });
  const leadDetails = [
    { entity_column_label: "Reason", value: isModalVisible?.reason },
    { entity_column_label: "Nature", value: isModalVisible?.nature },
    {
      entity_column_label: "Detailed Reason",
      value: isModalVisible?.detailed_reason,
    },
    {
      entity_column_label: "Amount",
      value: (
        <>
          <BaseCurrency />
          {amountFormat(isModalVisible?.amount)}
        </>
      ),
    },
    {
      entity_column_label: "Card Reference Number",
      value: isModalVisible?.account,
    },
    {
      entity_column_label: "Account Type",
      value: isModalVisible?.account_type,
    },
    {
      entity_column_label: "Remitter Account",
      value: isModalVisible?.remitter_account,
    },
    {
      entity_column_label: "Remitter Name",
      value: isModalVisible?.remitter_name,
    },
    {
      entity_column_label: "Payment Type",
      value: isModalVisible?.payment_type,
    },
    {
      entity_column_label: "Transaction Initiated At",
      value: new Date(isModalVisible?.txn_initiated_at).toLocaleString(),
    },
    {
      entity_column_label: "Created At",
      value: new Date(isModalVisible?.created_at).toLocaleString(),
    },
    {
      entity_column_label: "Status",
      value: (
        <span className={`status status_${isModalVisible?.status}`}>
          {isModalVisible?.status?.replace(/_/g, " ")}
        </span>
      ),
    },
  ];

  useEffect(() => {
    if (isModalVisible?.id)
      onCall({
        params: {
          dispute_id: isModalVisible?.id,
        },
      });
  }, [isModalVisible]);

  return (
    <>
      {isModalDispute && (
        <ReportDisputeModal
          visible={isModalVisible}
          onCancel={() => {
            setIsModalDispute(false);
          }}
        />
      )}
      <Modal
        title="Dispute Details"
        visible={isModalVisible}
        footer={[]}
        onCancel={handleCancel}
        className="right-alinged-modal"
      >
        <div className="tabs-sec">
          <ul>
            <li
              className={tab === "details" ? "active" : ""}
              onClick={() => {
                setTab("details");
              }}
            >
              Information
            </li>
            <li
              className={tab === "cm" ? "active" : ""}
              onClick={() => {
                setTab("cm");
              }}
            >
              Comments
            </li>
            <li
              className={tab === "ch" ? "active" : ""}
              onClick={() => {
                setTab("ch");
              }}
            >
              History
            </li>
          </ul>
        </div>
        {tab === "details" && (
          <>
            <div className="item-details p1 mt2">
              <div className="item-detail">
                <label>Remarks</label>
                <p title={isModalVisible?.remarks}>
                  {isModalVisible?.remarks
                    ? isModalVisible?.remarks
                    : "No remarks added"}
                </p>
              </div>
            </div>
            <div className="item-details p1 mt2">
              {leadDetails?.map((listElement, listIndex) => (
                <div className="item-detail" key={listIndex}>
                  <label>{listElement?.entity_column_label}</label>
                  <p title={listElement?.value}>
                    {listElement?.value ? listElement?.value : "-"}
                  </p>
                </div>
              ))}
              {/* <div>
                <label>Attached Files</label>
              </div> */}
              {isModalVisible?.attached_files?.map((eleFile, index) => (
                <div className="item-detail" key={index}>
                  {/* <label>Attached {index + 1}</label> */}
                  <label>{eleFile?.file_name}</label>
                  <div style={{ width: "10rem", height: "7rem" }}>
                    <img
                      src={`data:${eleFile?.content_type};base64, ${eleFile?.base64_string}`}
                      alt={`${eleFile?.content_type}`}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                </div>
              ))}
            </div>
            {/* <button className="primary-btn mt1">Update</button> */}

            {/* {
              (isModalVisible?.status === "Closed" || isModalVisible?.status == "resolved") ? (null) : (<button className="primary-btn mt1" onClick={() => {
                setIsModalDispute(true);
              }}>Update</button>)
            } */}
          </>
        )}
        {tab === "ch" && (
          <>
            {data?.response?.histories?.length ? (
              <div className="commentsSection mt2">
                <Steps
                  direction="vertical"
                  size="small"
                  current={data?.response?.histories?.length + 1 || 100}
                >
                  {data?.response?.histories &&
                    data?.response?.histories?.map(
                      ({ body, created_at, user_name, id, status }) => (
                        <Step
                          key={id}
                          title={body}
                          description={
                            created_at +
                            " | " +
                            user_name +
                            " | Action: " +
                            status
                          }
                          icon={<img src={History} alt="history" width={18} />}
                        />
                      )
                    )}
                </Steps>
              </div>
            ) : (
              <NodataComponent />
            )}
          </>
        )}
        {tab === "cm" && <Comments isModalVisible={isModalVisible} />}
      </Modal>
    </>
  );
};
const Comments = ({ isModalVisible }) => {
  const dispatch = useDispatch();
  const [input, setInput] = React.useState("");
  const createCom = useSelector((state) => state?.disputes?.create_comments);
  const commentsData = useSelector(
    (state) => state?.disputes?.comments?.data?.response?.comments
  );

  useEffect(() => {
    dispatch(
      getDisputeComments({
        dispute_id: isModalVisible?.id,
      })
    );
  }, []);

  useHandleResponse(
    CreateDisputeComments,
    createCom?.data?.message,
    createCom?.data?.message,
    createCom,
    () => {
      dispatch(
        getDisputeComments({
          dispute_id: isModalVisible?.id,
        })
      );
    }
  );
  const handleAddComment = () => {
    if (isModalVisible?.id) {
      dispatch(
        createDisputeComment({
          body: input,
          dispute_id: isModalVisible?.id,
        })
      );
      setInput("");
    } else {
      message.error(<span className="messageText">Comments are required</span>);
    }
  };
  return (
    <>
      <div className="addComment mt2 mb1">
        <Input
          placeholder="Enter Comment"
          value={input}
          onInput={(e) => setInput(e?.target?.value.trimStart())}
        />
        <Button
          key="1"
          className="formButton mt1"
          onClick={() => handleAddComment()}
        >
          Send
        </Button>
      </div>
      {commentsData?.length ? (
        <>
          <div className="commentsSection mt2">
            <Steps
              direction="vertical"
              size="small"
              current={commentsData.length + 1 || 100}
            >
              {commentsData &&
                commentsData.map(({ body, created_at, user_name, id }) => (
                  <Step
                    key={id}
                    title={body}
                    description={created_at + "/" + user_name}
                    icon={<img src={Comment} alt="history" width={18} />}
                  />
                ))}
            </Steps>
          </div>
        </>
      ) : (
        <NoCommentsComponent />
      )}
    </>
  );
};
// export const ContactHistory = ({ lead_id, type }) => {
//   const [showForm, setShowForm] = React.useState(false);

//   const { onCall: getLeadHistory, data } = usePayAxios({
//     api: apis.getUserLeadHistory,
//     method: "post",
//   });
//   const ValidationSchema = Yup.object().shape({
//     channel: Yup.string().when({
//       is: showForm,
//       then: Yup.string().required("Channel is required"),
//     }),
//     remarks: Yup.string().when({
//       is: showForm,
//       then: Yup.string().required("Remarks is required"),
//     }),
//     interaction_date: Yup.date().when({
//       is: showForm,
//       then: Yup.string().required("Interaction Date is required"),
//     }),
//   });

//   const { onCall } = usePayAxios({
//     api: apis.createLeadHistory,
//     method: "post",
//   });

//   const formik = useFormik({
//     initialValues: {
//       channel: "EMAIL",
//       remarks: "",
//       interaction_date: "",
//     },
//     validationSchema: ValidationSchema,
//     onSubmit: (values) => {
//       if (!showForm) {
//         setShowForm(true);
//         return;
//       }

//       onCall({
//         params: {
//           type,
//         },
//         data: {
//           channel: values.channel,
//           remarks: values.remarks,
//           interaction_date: values.interaction_date?.format("YYYY-MM-DD"),
//           lead_id,
//         },
//       }).then((res) => {
//         if (!res.error) {
//           getLeadHistory({
//             params: { pagination: false, lead_id, type },
//           });
//           setShowForm(false);
//         }
//       });
//     },
//   });

//   const contactHistory = data?.data;

//   useEffect(() => {
//     if (lead_id)
//       getLeadHistory({
//         params: { pagination: false, lead_id, type },
//       });
//   }, [lead_id]);

//   return (
//     <>
//       {!showForm &&
//         contactHistory?.map((contact, index) => (
//           <Card key={index} style={{ marginTop: "16px" }}>
//             <Row align="middle">
//               <Col span={2}>
//                 {contact.interaction_channel === "PHONE" ? (
//                   <PhoneOutlined style={{ fontSize: "24px" }} />
//                 ) : (
//                   <MailOutlined style={{ fontSize: "24px" }} />
//                 )}
//               </Col>
//               <Col span={22}>
//                 <div className="contact-title">
//                   {contact.interacted_by?.name} to Customer
//                 </div>
//                 <div className="contact-details">
//                   {moment(contact.created_at).format("DD-MM-YYYY")} | Remarks:{" "}
//                   {contact.remarks}
//                 </div>
//               </Col>
//             </Row>
//           </Card>
//         ))}
//       <form className="calc" onSubmit={formik.handleSubmit}>
//         {showForm ? (
//           <>
//             {" "}
//             <div className="pp-form-item mb1">
//               <label>Channel</label>
//               <div>
//                 <Select
//                   name="channel"
//                   value={formik.values.channel}
//                   onChange={(val) => {
//                     formik.setFieldValue("channel", val);
//                   }}
//                   options={[
//                     { value: "EMAIL", label: "Email" },
//                     { value: "PHONE", label: "Phone" },
//                     { value: "SMS", label: "SMS" },
//                   ]}
//                   className="w100"
//                 />
//               </div>
//               {formik.touched.channel && formik.errors.channel ? (
//                 <div className="error">{formik.errors.channel}</div>
//               ) : null}
//             </div>
//             <div className="pp-form-item">
//               <label>Remarks</label>
//               <Input.TextArea
//                 name="remarks"
//                 value={formik.values.remarks}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 placeholder="Enter Remarks"
//                 rows={"5"}
//               />
//               {formik.touched.remarks && formik.errors.remarks && (
//                 <div style={{ color: "red" }}>{formik.errors.remarks}</div>
//               )}
//             </div>
//             <div className="pp-form-item mt1">
//               <label>Interaction Date</label>
//               <DatePicker
//                 name="interaction_date"
//                 value={formik.values.interaction_date}
//                 onChange={(e) => {
//                   formik.setFieldValue("interaction_date", e);
//                 }}
//               />
//               {formik.touched.interaction_date &&
//                 formik.errors.interaction_date && (
//                   <div style={{ color: "red" }}>
//                     {formik.errors.interaction_date}
//                   </div>
//                 )}
//             </div>
//           </>
//         ) : null}

//         <button className="primary-btn" style={{ marginTop: "16px" }}>
//           + Add Action
//         </button>
//       </form>
//     </>
//   );
// };

export default DisputeModal;
